/* 🤖 this file was generated by svg-to-ts */
export const IconBigMediumDreieckKreisRechts: {
    name: 'big-medium-dreieck-kreis-rechts';
    data: string;
} = {
    name: 'big-medium-dreieck-kreis-rechts',
    data: `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 128 128"><path d="M93.68 57.43 54.94 33.26a8.3 8.3 0 0 0-12.68 7V87.7a8.3 8.3 0 0 0 12.68 7l38.74-24.13a5.5 5.5 0 0 0 .89-.7 8.3 8.3 0 0 0 0-11.74 5.5 5.5 0 0 0-.89-.7M52.26 84.62V43.38L85.32 64z"/><path d="M64 3a61 61 0 1 0 61 61A61.06 61.06 0 0 0 64 3m0 112a51 51 0 1 1 51-51 51.06 51.06 0 0 1-51 51"/></svg>`,
};
